import React, { Fragment } from "react";

import {
    Column,
    ColumnContainer,
    Divider,
    TitleContainer,
    SectionTitle,
    Paragraph,
} from "@beacharound/beacharound-ui";

export default function ServicesList({ services, title }) {

    if (!services || services.filter((service) => service?.service).length <= 0) {
        return <Fragment></Fragment>;
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text={title || "Servizi"} />
                    {services.filter(service => service?.service).map(({ service }, index) => {
                        const serviceName = service.name?.charAt(0) && service.name.charAt(0).toUpperCase() + service.name.slice(1)
                        return <Paragraph key={index} text={`• ${serviceName}`} />
                    })}
                </TitleContainer>
                <Divider />
            </Column>
        </ColumnContainer>
    );
}